import {
  useComparison,
  type ComparisonResult,
  type ComparisonSpec
} from "./useComparison";
import type { CompareToSelection, ServiceComparison } from "./types";

export interface UseServicesComparisonReturn
  extends ComparisonResult<ServiceComparison> {}

// Module-level so its identity is stable — `useComparison` keys memos on it.
const SERVICES_SPEC: ComparisonSpec<ServiceComparison> = {
  endpoint: "contracts/services/compare",
  idsField: "revenueItemIds",
  rowsField: "services",
  readRowId: (row) => row.revenueItemId,
  // Reported rather than dropped, unlike the contract grain.
  notFoundField: "notFoundRevenueItemIds"
};

/** Per-service movement for the rows currently on screen. */
export const useServicesComparison = (
  revenueItemIds: readonly string[],
  selection: CompareToSelection | undefined,
  enabled: boolean = true
): UseServicesComparisonReturn =>
  useComparison(revenueItemIds, selection, enabled, SERVICES_SPEC);
